import { Injectable } from '@angular/core';
import { BomCookieService } from '../core/services/bom-cookie/bom-cookie.service';
import { LocalStorageService } from '../core/services/localstorage/localstorage.service';
import { SkiftBrugerService } from './skift-bruger.service';

@Injectable({
  providedIn: 'root',
})
export class FuldmagtChoiceService {
  readonly key = 'bom_fuldmagt_choice';

  constructor(
    private cookieService: BomCookieService,
    private localStorageService: LocalStorageService,
    private skiftBrugerService: SkiftBrugerService
  ) {}

  set(value: string) {
    this.localStorageService.set(this.key, value);
    this.skiftBrugerService.setCookie(this.key, value).subscribe();
    this.cookieService.set(this.key, value);
  }

  remove() {
    this.localStorageService.remove(this.key);
    this.skiftBrugerService.removeCookie().subscribe();
    this.cookieService.delete(this.key);
  }

  getChoice() {
    return this.localStorageService.select<string>(this.key).value;
  }

  renew() {
    const value = this.getChoice();
    if (value) {
      this.set(value);
    }
  }
}
